const icons = [
  { name: 'arrow-up' },
  { name: 'arrow-right' },
  { name: 'arrow-left' },
  { name: 'arrow-down' },
  { name: 'arrows-vertical' },
  { name: 'arrows-horizontal' },
  { name: 'angle-up' },
  { name: 'angle-right' },
  { name: 'angle-left' },
  { name: 'angle-down' },
  { name: 'angle-double-up' },
  { name: 'angle-double-right' },
  { name: 'angle-double-left' },
  { name: 'angle-double-down' },
  { name: 'move' },
  { name: 'fullscreen' },
  { name: 'arrow-top-right' },
  { name: 'arrow-top-left' },
  { name: 'arrow-circle-up' },
  { name: 'arrow-circle-right' },
  { name: 'arrow-circle-left' },
  { name: 'arrow-circle-down' },
  { name: 'arrows-corner' },
  { name: 'split-v' },
  { name: 'split-v-alt' },
  { name: 'split-h' },
  { name: 'hand-point-up' },
  { name: 'hand-point-right' },
  { name: 'hand-point-left' },
  { name: 'hand-point-down' },
  { name: 'back-right' },
  { name: 'back-left' },
  { name: 'exchange-vertical' },
  { name: 'wand' },
  { name: 'save' },
  { name: 'save-alt' },
  { name: 'direction' },
  { name: 'direction-alt' },
  { name: 'user' },
  { name: 'link' },
  { name: 'unlink' },
  { name: 'trash' },
  { name: 'target' },
  { name: 'tag' },
  { name: 'desktop' },
  { name: 'tablet' },
  { name: 'mobile' },
  { name: 'email' },
  { name: 'star' },
  { name: 'spray' },
  { name: 'signal' },
  { name: 'shopping-cart' },
  { name: 'shopping-cart-full' },
  { name: 'settings' },
  { name: 'search' },
  { name: 'zoom-in' },
  { name: 'zoom-out' },
  { name: 'cut' },
  { name: 'ruler' },
  { name: 'ruler-alt-2' },
  { name: 'ruler-pencil' },
  { name: 'ruler-alt' },
  { name: 'bookmark' },
  { name: 'bookmark-alt' },
  { name: 'reload' },
  { name: 'plus' },
  { name: 'minus' },
  { name: 'close' },
  { name: 'pin' },
  { name: 'pencil' },
  { name: 'pencil-alt' },
  { name: 'paint-roller' },
  { name: 'paint-bucket' },
  { name: 'na' },
  { name: 'medall' },
  { name: 'medall-alt' },
  { name: 'marker' },
  { name: 'marker-alt' },
  { name: 'lock' },
  { name: 'unlock' },
  { name: 'location-arrow' },
  { name: 'layout' },
  { name: 'layers' },
  { name: 'layers-alt' },
  { name: 'key' },
  { name: 'image' },
  { name: 'heart' },
  { name: 'heart-broken' },
  { name: 'hand-stop' },
  { name: 'hand-open' },
  { name: 'hand-drag' },
  { name: 'flag' },
  { name: 'flag-alt' },
  { name: 'flag-alt-2' },
  { name: 'eye' },
  { name: 'import' },
  { name: 'export' },
  { name: 'cup' },
  { name: 'crown' },
  { name: 'comments' },
  { name: 'comment' },
  { name: 'comment-alt' },
  { name: 'thought' },
  { name: 'clip' },
  { name: 'check' },
  { name: 'check-box' },
  { name: 'camera' },
  { name: 'announcement' },
  { name: 'brush' },
  { name: 'brush-alt' },
  { name: 'palette' },
  { name: 'briefcase' },
  { name: 'bolt' },
  { name: 'bolt-alt' },
  { name: 'blackboard' },
  { name: 'bag' },
  { name: 'world' },
  { name: 'wheelchair' },
  { name: 'car' },
  { name: 'truck' },
  { name: 'timer' },
  { name: 'ticket' },
  { name: 'thumb-up' },
  { name: 'thumb-down' },
  { name: 'stats-up' },
  { name: 'stats-down' },
  { name: 'shine' },
  { name: 'shift-right' },
  { name: 'shift-left' },
  { name: 'shift-right-alt' },
  { name: 'shift-left-alt' },
  { name: 'shield' },
  { name: 'notepad' },
  { name: 'server' },
  { name: 'pulse' },
  { name: 'printer' },
  { name: 'power-off' },
  { name: 'plug' },
  { name: 'pie-chart' },
  { name: 'panel' },
  { name: 'package' },
  { name: 'music' },
  { name: 'music-alt' },
  { name: 'mouse' },
  { name: 'mouse-alt' },
  { name: 'money' },
  { name: 'microphone' },
  { name: 'menu' },
  { name: 'menu-alt' },
  { name: 'map' },
  { name: 'map-alt' },
  { name: 'location-pin' },
  { name: 'light-bulb' },
  { name: 'info' },
  { name: 'infinite' },
  { name: 'id-badge' },
  { name: 'hummer' },
  { name: 'home' },
  { name: 'help' },
  { name: 'headphone' },
  { name: 'harddrives' },
  { name: 'harddrive' },
  { name: 'gift' },
  { name: 'game' },
  { name: 'filter' },
  { name: 'files' },
  { name: 'file' },
  { name: 'zip' },
  { name: 'folder' },
  { name: 'envelope' },
  { name: 'dashboard' },
  { name: 'cloud' },
  { name: 'cloud-up' },
  { name: 'cloud-down' },
  { name: 'clipboard' },
  { name: 'calendar' },
  { name: 'book' },
  { name: 'bell' },
  { name: 'basketball' },
  { name: 'bar-chart' },
  { name: 'bar-chart-alt' },
  { name: 'archive' },
  { name: 'anchor' },
  { name: 'alert' },
  { name: 'alarm-clock' },
  { name: 'agenda' },
  { name: 'write' },
  { name: 'wallet' },
  { name: 'video-clapper' },
  { name: 'video-camera' },
  { name: 'vector' },
  { name: 'support' },
  { name: 'stamp' },
  { name: 'slice' },
  { name: 'shortcode' },
  { name: 'receipt' },
  { name: 'pin2' },
  { name: 'pin-alt' },
  { name: 'pencil-alt2' },
  { name: 'eraser' },
  { name: 'more' },
  { name: 'more-alt' },
  { name: 'microphone-alt' },
  { name: 'magnet' },
  { name: 'line-double' },
  { name: 'line-dotted' },
  { name: 'line-dashed' },
  { name: 'ink-pen' },
  { name: 'info-alt' },
  { name: 'help-alt' },
  { name: 'headphone-alt' },
  { name: 'gallery' },
  { name: 'face-smile' },
  { name: 'face-sad' },
  { name: 'credit-card' },
  { name: 'comments-smiley' },
  { name: 'time' },
  { name: 'share' },
  { name: 'share-alt' },
  { name: 'rocket' },
  { name: 'new-window' },
  { name: 'rss' },
  { name: 'rss-alt' },
  { name: 'control-stop' },
  { name: 'control-shuffle' },
  { name: 'control-play' },
  { name: 'control-pause' },
  { name: 'control-forward' },
  { name: 'control-backward' },
  { name: 'volume' },
  { name: 'control-skip-forward' },
  { name: 'control-skip-backward' },
  { name: 'control-record' },
  { name: 'control-eject' },
  { name: 'paragraph' },
  { name: 'uppercase' },
  { name: 'underline' },
  { name: 'text' },
  { name: 'Italic' },
  { name: 'smallcap' },
  { name: 'list' },
  { name: 'list-ol' },
  { name: 'align-right' },
  { name: 'align-left' },
  { name: 'align-justify' },
  { name: 'align-center' },
  { name: 'quote-right' },
  { name: 'quote-left' },
  { name: 'layout-width-full' },
  { name: 'layout-width-default' },
  { name: 'layout-width-default-alt' },
  { name: 'layout-tab' },
  { name: 'layout-tab-window' },
  { name: 'layout-tab-v' },
  { name: 'layout-tab-min' },
  { name: 'layout-slider' },
  { name: 'layout-slider-alt' },
  { name: 'layout-sidebar-right' },
  { name: 'layout-sidebar-none' },
  { name: 'layout-sidebar-left' },
  { name: 'layout-placeholder' },
  { name: 'layout-menu' },
  { name: 'layout-menu-v' },
  { name: 'layout-menu-separated' },
  { name: 'layout-menu-full' },
  { name: 'layout-media-right' },
  { name: 'layout-media-right-alt' },
  { name: 'layout-media-overlay' },
  { name: 'layout-media-overlay-alt' },
  { name: 'layout-media-overlay-alt-2' },
  { name: 'layout-media-left' },
  { name: 'layout-media-left-alt' },
  { name: 'layout-media-center' },
  { name: 'layout-media-center-alt' },
  { name: 'layout-list-thumb' },
  { name: 'layout-list-thumb-alt' },
  { name: 'layout-list-post' },
  { name: 'layout-list-large-image' },
  { name: 'layout-line-solid' },
  { name: 'layout-grid4' },
  { name: 'layout-grid3' },
  { name: 'layout-grid2' },
  { name: 'layout-grid2-thumb' },
  { name: 'layout-cta-right' },
  { name: 'layout-cta-left' },
  { name: 'layout-cta-center' },
  { name: 'layout-cta-btn-right' },
  { name: 'layout-cta-btn-left' },
  { name: 'layout-column4' },
  { name: 'layout-column3' },
  { name: 'layout-column2' },
  { name: 'layout-accordion-separated' },
  { name: 'layout-accordion-merged' },
  { name: 'layout-accordion-list' },
  { name: 'widgetized' },
  { name: 'widget' },
  { name: 'widget-alt' },
  { name: 'view-list' },
  { name: 'view-list-alt' },
  { name: 'view-grid' },
  { name: 'upload' },
  { name: 'download' },
  { name: 'loop' },
  { name: 'layout-sidebar-2' },
  { name: 'layout-grid4-alt' },
  { name: 'layout-grid3-alt' },
  { name: 'layout-grid2-alt' },
  { name: 'layout-column4-alt' },
  { name: 'layout-column3-alt' },
  { name: 'layout-column2-alt' },
  { name: 'flickr' },
  { name: 'flickr-alt' },
  { name: 'instagram' },
  { name: 'google' },
  { name: 'github' },
  { name: 'facebook' },
  { name: 'dropbox' },
  { name: 'dropbox-alt' },
  { name: 'dribbble' },
  { name: 'apple' },
  { name: 'android' },
  { name: 'yahoo' },
  { name: 'trello' },
  { name: 'stack-overflow' },
  { name: 'soundcloud' },
  { name: 'sharethis' },
  { name: 'sharethis-alt' },
  { name: 'reddit' },
  { name: 'microsoft' },
  { name: 'microsoft-alt' },
  { name: 'linux' },
  { name: 'jsfiddle' },
  { name: 'joomla' },
  { name: 'html5' },
  { name: 'css3' },
  { name: 'drupal' },
  { name: 'wordpress' },
  { name: 'tumblr' },
  { name: 'tumblr-alt' },
  { name: 'skype' },
  { name: 'youtube' },
  { name: 'vimeo' },
  { name: 'vimeo-alt' },
  { name: 'twitter' },
  { name: 'twitter-alt' },
  { name: 'linkedin' },
  { name: 'pinterest' },
  { name: 'pinterest-alt' },
  { name: 'themify-logo' },
  { name: 'themify-favicon' },
  { name: 'themify-favicon-alt' }
]

export default icons



// WEBPACK FOOTER //
// ./src/modules/Forms/IconField/iconsList.js